import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_VENDOR_ISSUES_SUGGESTION,
  GET_ONE_ISSUES_SUGGESTION,
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - ADD VENDOR ISSUES SUGGESTION ACTION
 *****************************************/
export const add_vendor_issues_suggestions =
  (formData, token, callback, actionBy) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    try {
      let add_vendor_issues_suggestions = await axios.post(
        `${serverApi}/vendor/issues`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_vendor_issues_suggestions.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(
          `<h4>${
            actionBy === "SUGGESTNEW"
              ? "Your request has been Submitted"
              : "Issues Add Successfully"
          }</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
        dispatch(get_vendor_issues_suggestions(token));
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET VENDOR ISSUES SUGGESTION ACTION
 *****************************************/
export const get_vendor_issues_suggestions = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_vendor_issues_suggestions = await axios.get(
      `${serverApi}/vendor/issues`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (get_vendor_issues_suggestions.data) {
      dispatch({
        type: GET_VENDOR_ISSUES_SUGGESTION,
        payload: get_vendor_issues_suggestions.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/*********************************************************
 * @DESC - GET PERTICULAR VENDOR ISSUES SUGGESTION ACTION
 ********************************************************/
export const get_only_one_issues_suggestions =
  (token, issueId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    //   dispatch({ type: SET_LOADER });
    try {
      let get_only_one_issues_suggestions = await axios.get(
        `${serverApi}/vendor/issues/${issueId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_only_one_issues_suggestions.data) {
        dispatch({
          type: GET_ONE_ISSUES_SUGGESTION,
          payload: get_only_one_issues_suggestions.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - UPDATE VENDOR ISSUE SUGGESSION ACTION
 *****************************************/
export const update_vendor_issues_suggestion =
  (formData, token, issueId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });
    try {
      let update_vendor_issues_suggestion = await axios.patch(
        `${serverApi}/vendor/issues/${issueId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_vendor_issues_suggestion.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Issue Status Update Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        // dispatch(get_only_one_issues_suggestions(token, issueId));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - COMMENT VENDOR TICKET ACTION
 *****************************************/
export const comment_vendor_issues_suggestion =
  (formData, token, issueId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });
    try {
      let comment_vendor_issues_suggestion = await axios.patch(
        `${serverApi}/vendor/issues/${issueId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (comment_vendor_issues_suggestion.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>comment Add Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        dispatch(get_only_one_issues_suggestions(token, issueId));

        // dispatch(get_vendor_issues_suggestions(token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
